import { render } from "./RatingEditorCmp.vue?vue&type=template&id=1c5f2b86&scoped=true"
import script from "./RatingEditorCmp.vue?vue&type=script&lang=js"
export * from "./RatingEditorCmp.vue?vue&type=script&lang=js"

import "./RatingEditorCmp.vue?vue&type=style&index=0&id=1c5f2b86&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5f2b86"]])

export default __exports__